import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TranslateContent from './TranslateContent';
import { useTranslation } from 'react-i18next';

interface TranslateSubtitleModalProps {
    isTranslateModalOpen: boolean;
    setIsTranslateModalOpen: (open: boolean) => void;
    availableSubtitleLanguages: any[];
    setAvailableSubtitleLanguages: (languages: any[]) => void;
}

const TranslateSubtitleModal = ({
    isTranslateModalOpen,
    setIsTranslateModalOpen,
    availableSubtitleLanguages,
    setAvailableSubtitleLanguages,
}: TranslateSubtitleModalProps) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={isTranslateModalOpen}
            onClose={() => setIsTranslateModalOpen(false)}
            disablePortal
        >
            <Box className="translate-subtitle-modal">
                <TranslateContent
                    availableSubtitleLanguages={availableSubtitleLanguages}
                    setAvailableSubtitleLanguages={setAvailableSubtitleLanguages}
                    setIsTranslateModalOpen={setIsTranslateModalOpen}
                />
                <Box className="translate-subtitle-modal-buttons">
                    <Button
                        onClick={() => setIsTranslateModalOpen(false)}
                        className="translate-subtitle-modal-cancel-btn"
                    >
                        {t('buttons.cancel')}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default TranslateSubtitleModal;